// reset link - 301
$(function(){
  if(window.location.pathname == "/collections/evening-dresses"){
    window.location.href="/collections/evening-dresses-gowns";
  }
})
function show_collection_description(){
  $('.collection_description_btn').bind('click',function(){
    $(this).hasClass("active") ? $(this).text("Read More >").removeClass("active") : $(this).text("See Less >").addClass("active");
    $(".collection_description-container .collection_description").slideToggle();
  });

  $('.collectionOtherContent .show-more-text').bind('click',function(){
    $(this).hasClass("active") ? $(this).text("Read More >").removeClass("active") : $(this).text("See Less >").addClass("active");
    $(this).prev(".t").toggleClass("active")
  });
}
$(document).ready(function () {
  show_collection_description();
});

$(document).ready(function() {
  $('.collectionFaqBox').each(function() {
    let content = $(this).html();
    content = content.replace(/2023|2024/g, '2025');
    $(this).html(content);
  });
});

$(function () {
  $('.collectionFaqText .show-more-text').bind('click',function(){
    $(this).hasClass("active") ? $(this).text("Read More >").removeClass("active") : $(this).text("See Less >").addClass("active");
    $(this).prev(".t").toggleClass("active")
  });
});

$(function () {
  let ww = $(window).width();
  if(ww >= 999){
    $(".product-item__image-wrapper").on("mouseenter", function() {
      let $video = $(this).find("#product-item__video");
      let video_length = $video.length;
      
      if(video_length >= 1) {
        let video = $video[0];
      
        if (!$(this).data('video-loaded')) {
          video.src = video.getAttribute('data-src');
          $(this).data('video-loaded', true);
        }
        
        $(this).find("#product-item__video").show();
        video.play();
        video.currentTime = 0;
      }
    });
    
    $(".product-item__image-wrapper").on("mouseleave", function() {
      let video_length = $(this).find("#product-item__video").length;
      if(video_length >= 1){
        let video = $(this).find("#product-item__video")[0];
        $(this).find("#product-item__video").hide();
        video.pause();
        video.currentTime = 0;
      }
    });
  }else{
    $("#product-item__video").remove();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-facet__product-list .product-item").forEach(product => {
    let imgElement = product.querySelector(".product-item__primary-image");
    if (!imgElement) return;

    let altText = imgElement.alt.trim();
    let colorMatch = altText.match(/#color_([\w\s&-]+)/i);
    if (!colorMatch) return;

    let currentColor = colorMatch[1].toLowerCase();

    let swatchList = product.querySelector(".color-swatch-list--mini");
    if (!swatchList) return;

    let matched = false;
    swatchList.querySelectorAll(".color-swatch").forEach(item => {
      let swatchColor = item.querySelector(".color-swatch__item").getAttribute("data-color")?.toLowerCase();
      let radio = item.querySelector(".color-swatch__radio");

      if (swatchColor === currentColor) {
        radio.checked = true;
        matched = true;
      } else {
        radio.checked = false;
      }
    });

    if (!matched) {
      let firstRadio = swatchList.querySelector(".color-swatch__radio");
      if (firstRadio) firstRadio.checked = true;
    }
  });
});



$(document).ready(function() {
  var mySwiper = new Swiper ('.color_filter', {
    slidesPerView: 12,
    paginationClickable: true,
    freeMode: true,
    scrollbar: '.swiper-scrollbar',
    breakpoints: {
      1600: {
        slidesPerView: 12,
      },
      1200: {
        slidesPerView: 10,
      },
      999: {
        slidesPerView: 9,
      },
      740: {
        slidesPerView: 8,
      },
      540: {
        slidesPerView: 6,
      },
      300: {
        slidesPerView: 5,
      }
    }
  });
    

  
    
  $('.product-facet__filter-item .color-swatch__radio').each(function() {
    var inputValue = $(this).val();
    
  });

  $('.color-list-item').each(function() {
    var colorLabel = $(this).attr('data-label');
    var colorSwatchId = $('.product-facet__filter-item .color-swatch__radio[value="'+ colorLabel +'"]').attr('id');
    
    $(this).attr('for', colorSwatchId);
    
    if (!$(this).attr('for')) {
      $(this).remove();
    }
  });

  $(".color_filter .color-item").hover(function(){
    var $length = $(this).find('.color-list-item').length;
    if ($length <= 0) {
      $(this).find('.color-list-box').remove();
      $(this).toggleClass('no-child')
    }
  })
  
  
  var ww = $(window).width();
  if(ww <= 999){
    $('.color-item').click(function() {
      console.log(ww,'click this');
        var $this = $(this);
        var $colorImgBox = $this.find('.color-img-box');
        var $colorListBox = $this.find('.color-list-box');
        var $img = $colorImgBox.find('span');

        
        if($this.hasClass('color-list-active')){
          $colorListBox.hide();
          $this.removeClass('color-list-active');
  
          $img.css({ width: '50px', height: '50px' });
  
          var $prevItem = $this.prev('.color-item');
          var $nextItem = $this.next('.color-item');
          
          if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '50px', height: '50px' });
          if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '50px', height: '50px' });
        }else{
          $('.color-item').find('.color-list-box').hide();
          $colorListBox.show();
          $('.color-item').removeClass('color-list-active');
          $this.addClass('color-list-active');
  
          $('.color-item').not($this).find('.color-img-box span').css({ width: '50px', height: '50px' });
          $img.css({ width: '60px', height: '60px' });
  
          var $prevItem = $this.prev('.color-item');
          var $nextItem = $this.next('.color-item');
          
          if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '55px', height: '55px' });
          if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '55px', height: '55px' });
  
          if (($this.is(':first-child') || $this.is(':nth-child(2)'))) $colorListBox.css({ left: '0', right: 'auto', transform: 'translateX(0)' });
          else if ($this.is(':last-child') || $this.is(':nth-last-child(2)')) $colorListBox.css({ left: 'auto', right: '0', transform: 'translateX(0)' });
          else $colorListBox.css({ left: '50%', transform: 'translateX(-50%)' });
        }
        
    });
  }else{
    $('.color-item').on('mouseenter', function() {
      console.log(ww,'mouseenter this');
        var $this = $(this);
        var $colorImgBox = $this.find('.color-img-box');
        var $colorListBox = $this.find('.color-list-box');
        var $img = $colorImgBox.find('span');

        $colorListBox.show();
        $this.addClass('color-list-active');

        $('.color-item').not($this).find('.color-img-box span').css({ width: '50px', height: '50px' });
        $img.css({ width: '60px', height: '60px' });

        var $prevItem = $this.prev('.color-item');
        var $nextItem = $this.next('.color-item');
        
        if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '55px', height: '55px' });
        if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '55px', height: '55px' });

        if (($this.is(':first-child') || $this.is(':nth-child(2)'))) $colorListBox.css({ left: '0', right: 'auto', transform: 'translateX(0)' });
        else if ($this.is(':last-child') || $this.is(':nth-last-child(2)')) $colorListBox.css({ left: 'auto', right: '0', transform: 'translateX(0)' });
        else $colorListBox.css({ left: '50%', transform: 'translateX(-50%)' });
    });

    $('.color-item').on('mouseleave', function() {
      console.log(ww,'mouseleave this');
        var $this = $(this);
        var $colorImgBox = $this.find('.color-img-box');
        var $colorListBox = $this.find('.color-list-box');
        var $img = $colorImgBox.find('span');

        $colorListBox.hide();
        $this.removeClass('color-list-active');

        $img.css({ width: '50px', height: '50px' });

        var $prevItem = $this.prev('.color-item');
        var $nextItem = $this.next('.color-item');
        
        if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '50px', height: '50px' });
        if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '50px', height: '50px' });
    });
  }
        
});

function color_mouseleave_filter() {
  $('.color-list-item').on('click', function() {
    console.log($(this).attr('data-label'));
    var $parent = $(this).closest('.color-item');
    
    setTimeout(() => {
      if($(this).hasClass('active')){
         $(this).removeClass("active");
      }else{
        $(this).addClass("active");
      }
      
      if ($parent.find('.color-list-item.active').length >= 1) {
        $parent.addClass('hascolor');
      } else {
        $parent.removeClass('hascolor');
      }
    }, 10);
  });
}

function getUrlParameters(param) {
  var pageUrl = window.location.search.substring(1); 
  var urlVars = pageUrl.split('&');
  var values = [];

  for (var i = 0; i < urlVars.length; i++) {
    var paramNameValue = urlVars[i].split('=');
    if (paramNameValue[0] === param) {
      values.push(decodeURIComponent(paramNameValue[1].replace(/\+/g, ' ')));
    }
  }
  
  return values;
}

function bindColorSwatchClick() {
  var colorValues = getUrlParameters('filter.v.option.color');

  setTimeout(function(){
    $(".color-list-item").removeClass('active');
    if (colorValues.length === 0) {
      $('.color-list-item').removeClass('active');
    } else {
      colorValues.forEach(function(colorValue) {
        $(".product-item-meta__swatch-list").find('div.color-swatch[data-colortip="'+colorValue+'"]').each(function() {
          $(this).click();
        });
        $('.color-list-item[data-label="'+colorValue+'"]').each(function(){
          $(this).addClass('active');
        });
        show_product_item_image()
      });
    }
  }, 20);
}

function checkActiveItems() {
  setTimeout(() => {
    $('.color-item').each(function() {
      var $this = $(this);
      if ($this.find('.color-list-item.active').length >= 1) {
        $this.addClass('hascolor');
      } else {
        $this.removeClass('hascolor');
      }
    });
    
    $(".color-list-all").each(function() {
      var $colorListAll = $(this);
      var $colorListWrap = $colorListAll.next('.color-list-wrap');
      var $colorListItems = $colorListWrap.find('.color-list-item');
  
      var allActive = $colorListItems.filter('.active').length === $colorListItems.length;
  
      if (allActive) {
        $colorListAll.addClass('on');
      } else {
        $colorListAll.removeClass('on');
      }
    });
  }, 30);
}

$(document).ready(function() {
  var $collection_title = $(".collection__title__h1 h1").text();
    if ($collection_title === 'Pink Bridesmaid Dresses'){
      $(".color-img-box").click(function() {
        var $parent = $(this).closest('.color-item');
        $parent.find(".color-list-all").trigger('click');
      });
    }
  
  $(".color-list-all").click(function () {
    $(this).next('.color-list-wrap').find('.color-list-item').click();
  });
  color_mouseleave_filter();
  bindColorSwatchClick();
  checkActiveItems();
});
